export default __webpack_public_path__ + "static/media/learose3-1440w.ce5a22f3.avif";